import { PkceUtil } from 'diam-connector';

import * as config from 'config';
import * as localStorage from 'utils/localStorageUtils';

export async function getDiamLoginUrl(languageCode: string, brand?: string) {
  const { codeVerifier, codeChallenge, codeChallengeMethod } =
    await PkceUtil.generateCodeVerifierAndCodeChallenge();

  localStorage.checkAvailability();
  localStorage.setItem('codeVerifier', { codeVerifier });
  localStorage.setItem('codeChallenge', { codeChallenge });

  const { clientId, diamApi } = config;
  const diamUrl = [`${diamApi}/oauth2/authorize`];
  const redirectUri = `${globalThis.location.origin}/authorize`;

  diamUrl.push(`?client_id=${clientId}`, `&redirect_uri=${redirectUri}`);

  if (brand) {
    diamUrl.push(`&brand=${brand}`);
  }

  diamUrl.push(
    `&code_challenge=${codeChallenge}`,
    `&code_challenge_method=${codeChallengeMethod}`,
    `&language=${languageCode}`
  );

  return diamUrl.join('');
}

export async function getDiamSsoUrl(
  ssoToken: string,
  languageCode: string,
  brand?: string
) {
  const { codeVerifier, codeChallenge, codeChallengeMethod } =
    await PkceUtil.generateCodeVerifierAndCodeChallenge();

  localStorage.checkAvailability();
  localStorage.setItem('codeVerifier', { codeVerifier });
  localStorage.setItem('codeChallenge', { codeChallenge });

  const { clientId, diamApi } = config;
  const diamUrl = [`${diamApi}/oauth2/login`];

  const redirectUri = `${globalThis.location.origin}/authorize`;

  diamUrl.push(`?client_id=${clientId}`, `&redirect_uri=${redirectUri}`);

  if (brand) {
    diamUrl.push(`&brand=${brand}`);
  }

  diamUrl.push(
    `&sso=${ssoToken}`,
    '&direct_grant=true',
    `&code_challenge=${codeChallenge}`,
    `&code_challenge_method=${codeChallengeMethod}`,
    `&language=${languageCode}`
  );

  return diamUrl.join('');
}

export function getCodeVerifier() {
  return localStorage.getItem<{ codeVerifier: string }>('codeVerifier')
    ?.codeVerifier;
}
